var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3411_2285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3411_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3432 14.862C6.0456 15.0761 5.71456 15.1535 5.35011 15.0941C4.98565 15.0347 4.69633 14.8562 4.48215 14.5586L1.36674 10.2298C1.15256 9.93218 1.07517 9.60115 1.13458 9.23669C1.19398 8.87224 1.37249 8.58292 1.6701 8.36873L10.3277 2.13792C10.6253 1.92374 10.9564 1.84635 11.3208 1.90576C11.6853 1.96516 11.9746 2.14367 12.1888 2.44128L15.3042 6.7701C15.5184 7.06771 15.5958 7.39874 15.5364 7.76319C15.477 8.12765 15.2985 8.41697 15.0008 8.63116L6.3432 14.862ZM5.56435 13.7798L14.222 7.54895L11.1066 3.22013L9.48328 4.38841L11.041 6.55282L9.95878 7.33167L8.40108 5.16726L7.31887 5.94611L8.87657 8.11052L7.79437 8.88937L6.23667 6.72496L5.15446 7.50381L6.71216 9.66822L5.62996 10.4471L4.07226 8.28266L2.44895 9.45094L5.56435 13.7798Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaRuler);
export default __webpack_public_path__ + "static/media/FaRuler.60ede247b09e387a7c447c8f53a77af2.svg";
export { ForwardRef as ReactComponent };